import { useCallback, useMemo } from 'react';
import qs from 'query-string';
import { getRootUrl } from '@utils/urlHelpers.util';
import { useLocation } from '@reach/router';
import { CULTURE_PARAMS, CURRENCY_PARAMS, LANGUAGE_PARAMS } from '@hooks/useGeoLocale';

const FORWARDED_PARAMS = new Set([...CULTURE_PARAMS, ...CURRENCY_PARAMS, ...LANGUAGE_PARAMS]);

export function useQueryParams(options?: qs.ParseOptions) {
  const search = new URL(typeof window !== 'undefined' ? window.location.href : getRootUrl('/')).search;
  return useMemo(() => qs.parse(search, { ...options, parseBooleans: true }), [options, search]);
}

export const useQueryParamsForwarder = () => {
  const location = useLocation();
  const search = location?.search ?? '';

  const wrapHref = useCallback(
    (href: string) => {
      const parsedQueryString = qs.parse(search);
      const filteredParams = Object.fromEntries(
        Object.entries(parsedQueryString).filter(([key]) => FORWARDED_PARAMS.has(key.toLowerCase()))
      );

      return qs.stringifyUrl({ url: href, query: filteredParams });
    },
    [search]
  );

  return { wrapHref };
};
